import React, { ButtonHTMLAttributes, DOMAttributes, forwardRef } from "react"
import { ButtonImage, CssButton } from "./style"

interface ButtonProps {
	title?: string
	image?: string
	active?: boolean
	className?: string
}

export const Button = forwardRef<
	HTMLButtonElement,
	ButtonProps & DOMAttributes<HTMLButtonElement> & ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
	const { title, image, active = false, className, ...rest } = props

	return (
		<CssButton active={active} {...rest} ref={ref} className={className}>
			{title}
			{image && <ButtonImage src={image} />}
		</CssButton>
	)
})
